import React from "react";
import { AI } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function AIPage({ onNavigate }) {
  return (
    <ServicePage hero={AI.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {AI.capabilities.map((c, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{c.title}</h4>
                <span className="capability-icon">{c.icon}</span>
              </div>
              <p>{c.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
